import module1 from './modules/1-introduccion.json';
import module2 from './modules/2-fundamentos-programacion.json';
import module3 from './modules/3-control-flujo1.json';
import module4 from './modules/4-control-flujo2.json';
import module5 from './modules/5-funciones.json';
import module6 from './modules/6-estructuras-de-datos.json';
import module7 from './modules/7-algoritmos.json'
import module8 from './modules/8-cierre.json';

export const courseData = [module1, module2, module3, module4, module5, module6, module7, module8];
